import { Box } from '@mui/material';
import React from 'react';
import Requests from './Requests';

const WorkOrderSpecialRequests = ({ specialRequests }) => {
  return specialRequests?.length ? (
    <Box
      p={{ xs: 2, md: 0 }}
      flexGrow={1}
      display="flex"
      flexDirection="column"
    >
      <Requests specialRequests={specialRequests} />
    </Box>
  ) : null;
};

export default WorkOrderSpecialRequests;
